module.exports = __webpack_public_path__ + "static/media/07_CALCINHA_DE_AMARRAR_LISA_02.1bac3eb4.jpg";